import React from 'react'

function Offer() {
  return (
    <div><h3 style={{fontFamily:"cursive"}}>Your Coupon Code</h3></div>
  )
}

export default Offer